// extracted by mini-css-extract-plugin
module.exports = {"container":"e_jI","readReviewButton":"e_kI","arrowRight":"e_lI","imageContainer":"e_mI","image":"e_nI","badge":"e_oI","badgeImage":"e_pI","content":"e_qI","title":"e_rI"};